import * as yup from 'yup';

import { ValidationError } from 'src/enums/Validation';
import { CreateParams } from 'src/repositories/organizationAdmin/TimeSheetsAdjustmentsRepository';
import { NestedTimeSheet } from 'src/types/resources/TimeSheet';
import { getMaxFieldLengthErrorMessage } from 'src/utils/validation';

export type OrgTimeSheetAdjustmentFormData = {
  hours: number;
  minutes: number;
  clientComment: string;
};

const MAX_HOURS_PER_DAY = 24;

export const validationSchema = yup.object({
  hours: yup
    .number()
    .min(0)
    .max(MAX_HOURS_PER_DAY)
    .required(ValidationError.default)
    .test(
      'max-hours-per-day',
      `You can’t track more than ${MAX_HOURS_PER_DAY} hours in a day.`,
      function isWithinDay(hours) {
        return (hours ?? 0) + (this.parent.minutes ?? 0) <= MAX_HOURS_PER_DAY;
      },
    )
    .label('Hours'),
  minutes: yup.number().min(0).required(ValidationError.default).label('Minutes'),
  clientComment: yup
    .string()
    .trim()
    .max(500, getMaxFieldLengthErrorMessage(500))
    .required(ValidationError.default)
    .label('Description'),
});

export const initialValues = (timeSheet: NestedTimeSheet): OrgTimeSheetAdjustmentFormData => {
  const [hoursValue, minutesValue = '0'] = timeSheet.hours.split('.');

  return {
    hours: Number(hoursValue),
    minutes: Number(minutesValue) / 100,
    clientComment: '',
  };
};

export const attributesToSubmit = (parentId: ID, values: OrgTimeSheetAdjustmentFormData): CreateParams => {
  const { hours, minutes, clientComment } = values;

  return {
    parentId,
    hours: String(hours + minutes),
    clientComment: clientComment.trim(),
  };
};
